import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { UseFormReturn } from "react-hook-form";
import type { AuthProviderCustomForm } from "@/app/oauth/types";

type TokenEndpointFieldProps = {
  form: UseFormReturn<AuthProviderCustomForm, unknown>;
};

export const TokenEndpointField = ({ form }: TokenEndpointFieldProps) => (
  <FormField
    control={form.control}
    name="oauth2.token_request.endpoint"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Token Endpoint</FormLabel>
        <FormControl>
          <Input placeholder="https://example.com/oauth/token" {...field} />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
);
